class TrustCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-trust-scroll]');
    this.dots = Array.from(this.querySelectorAll('[data-trust-dot]'));

    if (!this.scroller || this.dots.length < 2) return;

    this.slides = Array.from(this.scroller.children);

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            const index = this.slides.indexOf(entry.target);
            if (index > -1) this.setActiveDot(index);
          }
        });
      },
      { root: this.scroller, threshold: [0.6] }
    );

    this.slides.forEach((slide) => this.observer.observe(slide));

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  }

  setActiveDot(index) {
    this.dots.forEach((dot, i) => {
      if (i === index) {
        dot.setAttribute('data-active', '');
      } else {
        dot.removeAttribute('data-active');
      }
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get('trust-carousel')) {
  customElements.define('trust-carousel', TrustCarousel);
}
